/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { getColor, pd } from '@airasia-phoenix/react-native/utils';
import {
  getDateAfterSeconds,
  getLastDateOfMonthFromCurrentDate,
} from '@airasia-phoenix/react-native/utils/dateUtils';

const Constants = {
  get CALENDAR_START_DATE() {
    return new Date();
  },
  get CALENDAR_END_DATE() {
    const durationInDays = 365;
    const durationInHours = durationInDays * 24;
    const durationInMinutes = durationInHours * 60;
    const durationInSeconds = durationInMinutes * 60;
    const dateAfter12Months = getDateAfterSeconds(
      new Date(),
      durationInSeconds,
    );
    //12 jan 2024 (current Date) -> 12 jan 2025
    const lastDateOfTheMonth =
      getLastDateOfMonthFromCurrentDate(dateAfter12Months); // 12 jan 2025 -> 31 jan 2025
    return lastDateOfTheMonth;
  },
  BOTTOM_SHEET_HEIGHT: '85%',
  LOWER_PRICE_COLOR: getColor(pd.sys.colour.sentiment_success),
  LOW_FARE_DATE_FORMAT: 'dd/MM/yyyy',
  get DAYS_GAP_DEPART_RETURN_DATE() {
    const durationInDays = 3;
    const durationInHours = durationInDays * 24;
    const durationInMinutes = durationInHours * 60;
    const durationInSeconds = durationInMinutes * 60;
    return durationInSeconds;
  }, //for the days gap between depart and return date
  UNAVAILABLE_PRICE_PLACEHOLDER: '...',
  WAIT_TRANSLATION_API: 1500,
  DEFAULT_DEPART_DAYS: 7,
  DEFAULT_RETURN_DAYS: 10,
  SECONDS_IN_DAY: 24 * 60 * 60, // number of seconds in one day
};

export default Constants;
